import { styled } from 'linaria/react';
import React, { useState } from 'react';
import theme from 'clad-ui/theme/chotot';
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "t1h2opep"
});
const Ul = /*#__PURE__*/styled("ul")({
  name: "Ul",
  class: "u1uy6a9l",
  vars: {
    "u1uy6a9l-0": [({
      up
    }) => up ? '50px' : 'auto']
  }
});
const Li = /*#__PURE__*/styled("li")({
  name: "Li",
  class: "l193bxy7"
});
const A = /*#__PURE__*/styled("a")({
  name: "A",
  class: "a85zez1"
});
const ReadMore = /*#__PURE__*/styled("p")({
  name: "ReadMore",
  class: "r1bkqc6t"
});
const Ra = /*#__PURE__*/styled("a")({
  name: "Ra",
  class: "r1r3obiy"
});
const EXPAND_TEXT = 'Mở rộng';
const COLLAPSE_TEXT = 'Thu gọn';
function Keywords(props) {
  const {
    dataSource = [],
    onClick,
    isMobile
  } = props;
  const [up, setUp] = useState(isMobile && dataSource.length > 10);
  return <>
      <Title>Các từ khóa phổ biến</Title>
      <Ul up={up}>
        {dataSource.map((item, index) => <Li className="col-sm-4" itemScope itemType="http://schema.org/ListItem" itemProp="itemListElement" key={index.toString()}>
            <meta itemProp="position" content={index + 1} />
            <A onClick={() => onClick(item)} itemProp="url" href={item.uri}>
              <span>{item.title}</span>
            </A>
          </Li>)}
      </Ul>
      {dataSource.length > 10 && isMobile && <ReadMore>
          {up ? <Ra onClick={() => setUp(false)}>
              {EXPAND_TEXT} <i id="arrowIcon" className="fa fa-angle-down" aria-hidden="true" />
            </Ra> : <Ra onClick={() => setUp(true)}>
              {COLLAPSE_TEXT} <i id="arrowIcon" className="fa fa-angle-up" aria-hidden="true" />
            </Ra>}
        </ReadMore>}
    </>;
}
export default Keywords;

require("../../../.linaria-cache/src/components/Keywords/index.linaria.module.css");